import { render, staticRenderFns } from "./AssociatoDetail.vue?vue&type=template&id=73fc8c94&"
import script from "./AssociatoDetail.vue?vue&type=script&lang=ts&"
export * from "./AssociatoDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports